import { getObjectId } from '@/helpers/object.id.helper';
import type { Mode } from '@/types/entity-mode';
import type { FlowDto, FlowMode } from '@/types/dtos/flows/response/flow.dto';

/** Map backend PLAY documents to the UI mode used for mode switching and comparisons. */
export function toFlowUiMode(mode: FlowMode | undefined, fallback: Mode = 'ORGANIZE'): Mode {
  if (mode === 'PLAY') return 'PLAN';
  if (mode === 'PLAN' || mode === 'ORGANIZE' || mode === 'PERFORM') return mode;
  return fallback;
}

/** Map PLAY (or scoped write) payloads to master PLAN identity for PLAN-mode UI and caches. */
export function normalizeFlowForPlanView(flow: FlowDto, masterPlanFlowId: string): FlowDto {
  if (flow.mode !== 'PLAY') {
    return flow;
  }
  const originId = flow.origin ? getObjectId(flow.origin) : masterPlanFlowId;
  return {
    ...flow,
    mode: 'PLAN',
    id: masterPlanFlowId,
    origin: originId ?? masterPlanFlowId,
  };
}
